import { Product } from '../../types';

export const series0375Products: Product[] = [
  {
    id: "bt-0375-swt037501",
    name: "0375 Series Terminal - No 18C 9.5 Female Slot (SWT037501)",
    slug: "0375-series-terminal-no-18c-9-5-female-slot-swt037501",
    category: "Brass Terminal",
    subcategory: "0375 Series",
    description: "No 18C 9.5mm female slot terminal for extra heavy-duty applications. High conductivity brass construction.",
    partNumber: "SWT037501",
    featured: true,
    specifications: {
      "Tab Size Ø": "9.35 mm",
      "Cable Size SQ. MM": "3.30-4.40",
      "Description": "No 18C 9.5 Female Slot",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-N/A Cut-1000",
    },
    images: ["/products/brass-terminals/0312-series/SWT037501.jpg"],
    tags: ["terminal", "0375", "brass", "female", "slot", "9.5mm"],
    applications: ["Automotive", "Extra Heavy Duty"],
  },
  {
    id: "bt-0312-swt031221",
    name: "0312 Series Terminal - 8.3 Female Flag (SWT031221)",
    slug: "0312-series-terminal-8-3-female-flag-swt031221",
    category: "Brass Terminal",
    subcategory: "0375 Series",
    description: "8.3mm female flag terminal with right-angle bend. Flag terminal for space-constrained applications.",
    partNumber: "SWT031221",
    specifications: {
      "Tab Size Ø": "8.85 mm",
      "Cable Size SQ. MM": "2.50-3.50",
      "Description": "8.3 Female Flag",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2000 Cut-1000",
    },
    images: ["/products/brass-terminals/0312-series/SWT031221.jpg"],
    tags: ["terminal", "0375", "brass", "female", "flag", "8.3mm"],
    applications: ["Automotive", "Heavy Duty", "Space Constrained"],
  },
  {
    id: "bt-0312-swt031222",
    name: "0312 Series Terminal - 8.3 Female Flag (SWT031222)",
    slug: "0312-series-terminal-8-3-female-flag-swt031222",
    category: "Brass Terminal",
    subcategory: "0375 Series",
    description: "8.3mm female flag terminal. Alternative flag design for space-constrained applications.",
    partNumber: "SWT031222",
    specifications: {
      "Tab Size Ø": "8.85 mm",
      "Cable Size SQ. MM": "2.50-3.50",
      "Description": "8.3 Female Flag",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2000 Cut-1000",
    },
    images: ["/products/brass-terminals/0312-series/SWT031222.jpg"],
    tags: ["terminal", "0375", "brass", "female", "flag", "8.3mm"],
    applications: ["Automotive", "Heavy Duty", "Space Constrained"],
  },
  {
    id: "bt-0312-swt031226",
    name: "0312 Series Terminal - 8.3 China (SWT031226)",
    slug: "0312-series-terminal-8-3-china-swt031226",
    category: "Brass Terminal",
    subcategory: "0375 Series",
    description: "8.3mm female terminal - China variant. High conductivity brass construction.",
    partNumber: "SWT031226",
    specifications: {
      "Tab Size Ø": "8.85 mm",
      "Cable Size SQ. MM": "2.30-3.30",
      "Description": "8.3 China",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/0312-series/SWT031226.jpg"],
    tags: ["terminal", "0375", "brass", "female", "china", "8.3mm"],
    applications: ["Automotive", "Heavy Duty"],
  },
  {
    id: "bt-0312-swt031251",
    name: "0312 Series Terminal - Button Terminal (SWT031251)",
    slug: "0312-series-terminal-button-terminal-swt031251",
    category: "Brass Terminal",
    subcategory: "0375 Series",
    description: "Button terminal for compact applications. High conductivity brass construction.",
    partNumber: "SWT031251",
    specifications: {
      "Tab Size Ø": "N/A",
      "Cable Size SQ. MM": "1.90-2.80",
      "Description": "Button Terminal",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-7000 Cut-1000",
    },
    images: ["/products/brass-terminals/0312-series/SWT031251.jpg"],
    tags: ["terminal", "0375", "brass", "button", "compact"],
    applications: ["Automotive", "Compact Applications"],
  }
];
